import moment from 'moment-timezone';

const IST_TIMEZONE = 'Asia/Kolkata';

/**
 * Format UTC timestamp to IST time (HH:mm)
 * @param {string} utcIsoString - UTC ISO string (e.g., "2024-01-15T10:30:00.000Z")
 * @param {string} format - Moment format string (default: "HH:mm")
 * @returns {string} Formatted time in IST
 */
export const formatUTCtoIST = (utcIsoString, format = "HH:mm") => {
  if (!utcIsoString) return "--";
  return moment.utc(utcIsoString).tz(IST_TIMEZONE).format(format);
};

/**
 * Format UTC timestamp to IST date-time
 * @param {string} utcIsoString - UTC ISO string
 * @param {string} format - Moment format string (default: "DD-MM-YYYY HH:mm")
 * @returns {string} Formatted date-time in IST
 */
export const formatUTCDateTimeToIST = (utcIsoString, format = "DD-MM-YYYY HH:mm") => {
  if (!utcIsoString) return "--";
  return moment.utc(utcIsoString).tz(IST_TIMEZONE).format(format);
};

/**
 * Format UTC to IST date only
 * @param {string} utcIsoString - UTC ISO string
 * @param {string} format - Moment format string (default: "DD-MM-YYYY")
 * @returns {string} Formatted date in IST
 */
export const formatUTCDateToIST = (utcIsoString, format = "DD-MM-YYYY") => {
  if (!utcIsoString) return "--";
  return moment.utc(utcIsoString).tz(IST_TIMEZONE).format(format);
};

/**
 * Create UTC ISO string from IST date + time
 * User selects date "2024-01-15" and time "10:30" thinking in IST
 * This converts to UTC ISO string
 * @param {Date|string} date - Date object or date string
 * @param {string} time - Time string in HH:mm format
 * @returns {string} UTC ISO string
 */
export const createUTCFromISTDateTime = (date, time) => {
  const dateStr = moment(date).format('YYYY-MM-DD');
  const dateTimeStr = `${dateStr} ${time}`;
  return moment.tz(dateTimeStr, 'YYYY-MM-DD HH:mm', IST_TIMEZONE).utc().toISOString();
};

/**
 * Convert date + time to UTC for API submission
 * @param {Date} date - JavaScript Date object
 * @param {number} hours - Hours (0-23) in IST
 * @param {number} minutes - Minutes (0-59)
 * @returns {string} UTC ISO string
 */
export const createUTCFromISTComponents = (date, hours, minutes) => {
  return moment.tz(date, IST_TIMEZONE)
    .hours(hours)
    .minutes(minutes)
    .seconds(0)
    .milliseconds(0)
    .utc()
    .toISOString();
};

